<boi-mortgage-app-section-navigation #boiTabWrapper (detectChanges)="changeDetectorRef.detectChanges()">
  <div class="title-bar">
    <h1 class="title-bar-text vo-heading-regular-22">{{currentApplicant?.Forename}} {{currentApplicant?.Surname}}</h1>

    <span
      class="required-label vo-body-regular-14 vo-display-none"
      [innerHtml]="referenceDataLabels.MandatoryFields | localizeLabel"
    ></span>
  </div>
  <boi-form-information-box [message]="referenceDataLabels.NoteIndividualWillBeCrediId"></boi-form-information-box>

  <div class="buttons__bar buttons__bar_right d-flex flex-row-reverse mb-15">
    <button
      class="primary-button vo-secondary-button-1 full-width-md-button"
      (click)="deleteApplicantDialogOpened = true"
      [disabled]="currentApplicantIndex < 1 || mortgageApplication?.IsApplicationReadOnly"
      *ngIf="!mortgageApplication?.IsFactFindReadOnly"
    >
      {{referenceDataLabels.DeleteApplicant|localizeLabel}}
    </button>
    <ng-container *ngIf="deleteApplicantDialogOpened">
      <boi-confirmation-dialog
        class="vo-modal vo-modal--standard"
        [(opened)]="deleteApplicantDialogOpened"
        [titleLabel]="referenceDataLabels.DeleteApplicantModalTitle"
        [confirmationLabel]="referenceDataLabels.DeleteApplicantModalText"
        [confirmationButtonLabel]="referenceDataLabels.Delete"
        (confirmAction)="deleteApplicant()"
        [isVoWarningDialog]="true"
      >
      </boi-confirmation-dialog>
    </ng-container>
  </div>
  <boi-accordion>
    <div class="vo-separator-line my-15"></div>
    <boi-accordion-item
      #accordionItem1
      [title]="referenceDataLabels.AboutYouId | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.AboutYouId | removeWhiteSpaces"
      [data]="sections.Applicant[currentApplicantIndex]?.AboutYou"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.Applicant[currentApplicantIndex]?.AboutYou"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-applicant-details [(applicant)]="currentApplicant" [applicantIndex]="currentApplicantIndex">
      </boi-applicant-details>
      <boi-save-application
        class="buttons__bar"
        [saveButtonLabel]="saveContinueButtonLabel"
        [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.AboutYouId)"
        (save)="boiTabWrapper.goToNextIncompleted(accordionItem1)"
      >
      </boi-save-application>
    </boi-accordion-item>
    <div class="vo-separator-line my-15"></div>
    <boi-accordion-item
      #accordionItem2
      [title]="referenceDataLabels.PlacesYouHaveLived | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.PlacesYouHaveLived | removeWhiteSpaces"
      [data]="sections.Applicant[currentApplicantIndex]?.PlacesYouveLived"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.Applicant[currentApplicantIndex]?.PlacesYouveLived"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-applicant-lived-places
        [(applicant)]="currentApplicant"
        [(residences)]="currentApplicant.ApplicantResidences"
        [applicantIndex]="currentApplicantIndex"
      >
      </boi-applicant-lived-places>
      <boi-save-application
        class="buttons__bar"
        [saveButtonLabel]="saveContinueButtonLabel"
        [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.PlacesYouHaveLived)"
        (save)="boiTabWrapper.goToNextIncompleted(accordionItem2)"
      >
      </boi-save-application>
    </boi-accordion-item>
    <div class="vo-separator-line my-15"></div>
    <boi-accordion-item
      #accordionItem3
      [title]="referenceDataLabels.YourIncomeId | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.YourIncomeId | removeWhiteSpaces"
      [data]="sections.Applicant[currentApplicantIndex]?.YourIncome"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.Applicant[currentApplicantIndex]?.YourIncome"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-applicant-income
        *ngFor="let employment of currentApplicant.ApplicantEmployments; let employmentIndex = index"
        [employmentIndex]="employmentIndex"
        [(applicant)]="currentApplicant"
        [applicantIndex]="currentApplicantIndex"
      >
      </boi-applicant-income>
      <boi-save-application
        class="buttons__bar"
        [saveButtonLabel]="saveContinueButtonLabel"
        [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.YourIncomeId)"
        (save)="boiTabWrapper.goToNextIncompleted(accordionItem3)"
      >
      </boi-save-application>
    </boi-accordion-item>
    <div class="vo-separator-line my-15"></div>
    <boi-accordion-item
      #accordionItem4
      [title]="referenceDataLabels.YourProperties | localizeLabel"
      [class]="'js-section-' + referenceDataLabels.YourProperties | removeWhiteSpaces"
      [data]="sections.Applicant[currentApplicantIndex]?.YourCurrentProperties"
    >
      <boi-progress-stepper-item
        header
        [status]="sections.Applicant[currentApplicantIndex]?.YourCurrentProperties"
        [hasSubmitValidationError]="hasSubmitValidationError"
      >
      </boi-progress-stepper-item>
      <boi-applicant-current-properties
        [(applicant)]="currentApplicant"
        [applicantIndex]="currentApplicantIndex"
        (addApplicant)="addApplicant()"
      >
      </boi-applicant-current-properties>
      <boi-save-application
        class="buttons__bar"
        [saveButtonLabel]="saveContinueToNextStepButtonLabel"
        [hideActionButton]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication.IsFactFindReadOnly)"
        (cancel)="boiTabWrapper.goToSection(referenceDataLabels.YourProperties)"
        (save)="boiTabWrapper.goToNextIncompleted(accordionItem4)"
      ></boi-save-application>
    </boi-accordion-item>
  </boi-accordion>
</boi-mortgage-app-section-navigation>
